module.exports = __webpack_public_path__ + "img/silver_medal.28ba9c62.png";